import * as React from "react";
import styles from "./index.module.css";
import PlusCircle from "../../images/plus-circle.png";
import { AddCircle, CrossIcon, DeleteIcon, EditIcon } from "../icons";
import storageService from "../../app/services/storageService";
import ReactCrop from "react-image-crop";
import EditImageModal from "../Modals/EditImageModal";

const SelectFileButton = ({ setFile, file, label, onFileDelete, props }) => {
  const inputRef = React.useRef();
  const [edit, setEdit] = React.useState(false);

  const dragOver = (e) => {
    e.preventDefault();
  };

  const dragEnter = (e) => {
    e.preventDefault();
  };

  const onDrop = (e) => {
    e.preventDefault();
    setFile(e.dataTransfer.files);
  };

  const dragLeave = (e) => {
    e.preventDefault();
  };
  if (label === "add" || !file) {
    return (<label className={`${styles.image_grid_item} ${styles.add} add`}
      onDragOver={dragOver}
      onDragEnter={dragEnter}
      onDrop={onDrop}
      onDragLeave={dragLeave}
      htmlFor="add-image"
    >
      <AddCircle size={40} fill={"transparent"} className={`${styles.add_icon}`} />
      <input
        type="file"
        id="add-image"
        accept="image/*"
        ref={inputRef}
        multiple
        onChange={(e) => {
          setFile(e.target.files)
        }}
      />
    </label>)
  }

  return (
    <div className={styles.image_grid_item} onClick={(e) => {
      // Prevent file selection when clicking on the cross or edit icon
      [styles.image_grid_item, 'image'].forEach((className) => {
        if (e.target.classList.contains(className)) {
          inputRef.current.click()
        }
      });

    }}
      style={label ? {
        border: "3px solid var(--red)"
      } : {}}
      onDrop={(e) => {
        e.preventDefault()
        if (e.dataTransfer.files.length === 0) return;
        setFile(e.dataTransfer.files[0])
      }}
      onDragOver={dragOver}
      onDragEnter={dragEnter}
      onDragLeave={dragLeave}
    >
      <input className={"file"} type="file" onChange={(e) => setFile(e.target.files[0])} ref={inputRef} />
      <img onContextMenu={
        (e) => {
          e.preventDefault()
        }
      }  className="image" src={file.name ? URL.createObjectURL(file) : (!file.file ? `${storageService.publicUrl(file.path)}` : URL.createObjectURL(file.file))} alt={"placeholder"} style={props?.single && { height: "100%", background: "var(--lightGrey)", objectFit: "contain", pointerEvents: "none" }} />
      <CrossIcon className={styles.cross_icon} onClick={(e) => {
        e.stopPropagation()
        onFileDelete()
      }} />
      <svg className={styles.edit_icon} onClick={(e) => {
        e.stopPropagation()
        setEdit(true)
        }} width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2043_64)">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 6.31111V8H1.68889L6.57778 3.06667L4.88889 1.37778L0 6.31111ZM7.86667 1.77778C8.04445 1.6 8.04445 1.33333 7.86667 1.15556L6.84444 0.133333C6.66667 -0.0444444 6.4 -0.0444444 6.22222 0.133333L5.42222 0.933333L7.11111 2.62222L7.86667 1.77778Z" fill="#851718" />
        </g>
        <defs>
          <clipPath id="clip0_2043_64">
            <rect width="8" height="8" fill="white" />
          </clipPath>
        </defs>
      </svg>


      {label && <div className={styles.chip}>Featured</div>}
      {edit && <EditImageModal setFile={setFile} onClose={() => setEdit(false)} file={file.name ? URL.createObjectURL(file) : (!file.file ? `${storageService.publicUrl(file.path)}` : URL.createObjectURL(file.file))} />}
    </div>
  )
};

export default SelectFileButton;
